import React from "react";
import { Link } from "react-router-dom";

/**
 * Displays a library-style grid of real book covers.
 * Each cover is clickable and links to /{basePath}/{slug}.
 *
 * aspect: "vertical" (default, 7/10 book cover) | "square" (1/1 poster)
 */
export default function CoverGrid({ items, basePath, testId, aspect = "vertical" }) {
  const aspectClass = aspect === "square" ? "aspect-square" : "aspect-[7/10]";
  return (
    <div
      data-testid={testId || "cover-grid"}
      className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6 sm:gap-8"
    >
      {items.map((item) => (
        <Link
          key={item.slug}
          to={`${basePath}/${item.slug}`}
          data-testid={`cover-${item.slug}`}
          className="group block"
        >
          <div className={`relative ${aspectClass} rounded-xl overflow-hidden bg-white/[0.02] border border-white/5 shadow-[0_10px_40px_-15px_rgba(0,0,0,0.6)] transition-all duration-500 group-hover:-translate-y-2 group-hover:shadow-[0_25px_60px_-15px_rgba(16,185,129,0.35)] group-hover:border-emerald-400/25`}>
            <img
              src={item.cover}
              alt={item.title}
              loading="lazy"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
          </div>
          <div className="mt-4 px-1">
            <div className="text-sm sm:text-base font-light text-white leading-snug tracking-tight group-hover:text-emerald-200 transition-colors">
              {item.title}
            </div>
            {item.subtitle && (
              <div className="mt-1 text-[11px] font-light text-white/40 leading-relaxed line-clamp-2">
                {item.subtitle}
              </div>
            )}
          </div>
        </Link>
      ))}
    </div>
  );
}
